const tab_sections = {
    identity: 'Identidade',
    integrations: 'Conexões',
    login_security: 'Acesso e segurança',
    permissions: 'Permissões',
    automation: 'Automação',
    platform: 'Plataforma',
    overview: 'Visão geral',
    authentication: 'Autenticação',
    authorization: 'Autorização',
    users: 'Usuários',
    developer: 'Desenvolvedor',
    tenant: 'Inquilino',
};
export default Object.freeze(tab_sections);
